import { RobocloudDTO } from '@robocorp/robocloud-common/lib/types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardSecretsApi } from '~/utils/api';

export const getSecretListItems = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardSecretsApi.get<RobocloudDTO.SecretListItem[]>(`/workspaces/${workspaceId}/secrets`);

export const getSecretByName = async ({
  workspaceId,
  name,
  publicKey,
  encryptionScheme,
}: { name: string; publicKey: string; encryptionScheme: string } & WithWorkspaceId) =>
  dashboardSecretsApi.get<RobocloudDTO.EncryptedSecretV2>(
    `/workspaces/${workspaceId}/secrets/${name}`,
    {
      publicKey,
      encryptionScheme,
    },
  );

export const putSecretByName = async ({
  workspaceId,
  name,
  updateDetails,
}: {
  name: string;
  updateDetails: RobocloudDTO.EncryptedSecretV1;
} & WithWorkspaceId) =>
  dashboardSecretsApi.put<RobocloudDTO.Secret>(`/workspaces/${workspaceId}/secrets/${name}`, {
    ...updateDetails,
  });

export const deleteSecretByName = async ({
  workspaceId,
  name,
}: { name: string } & WithWorkspaceId) =>
  dashboardSecretsApi.delete<RobocloudDTO.Secret>(`/workspaces/${workspaceId}/secrets/${name}`);

export const getPublicKey = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardSecretsApi.get<string>(`/workspaces/${workspaceId}/publicKey`);
